export default __webpack_public_path__ + "static/media/hall4.1d30d8ef.jpeg";